import clsx from "clsx";
import React from "react";
import { List, ListProps, Typography, Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ClientListItem } from "./ClientListItem";
import { ClientInfoDto } from "@growth-machine-llc/stridist-api-client";
import { EnrollDialogEmpty } from "../../dialog/EnrollDialogEmpty";

const useStyles = makeStyles((theme) => ({
  root: {},

  empty: {
    marginTop: theme.spacing(3),
  },
}));

export interface ClientListProps extends Omit<ListProps, "onSelect"> {
  clients: ClientInfoDto[];
  onLoadMore: () => void;
  loading: boolean;
  hasNext: boolean;
  onSelect?: (event: React.MouseEvent, client: ClientInfoDto) => void;
  selectedClient?: ClientInfoDto | null;
  singleSelect?: boolean;
  debounceQuery?: string;
}

export function ClientList(props: ClientListProps) {
  const {
    className,
    onSelect,
    onLoadMore,
    clients,
    loading,
    hasNext,
    selectedClient,
    singleSelect,
    debounceQuery,
    ...other
  } = props;
  const s = useStyles();

  const handleMoreClick = React.useCallback(() => {
    !loading && onLoadMore();
  }, [loading, onLoadMore]);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLElement>, client: ClientInfoDto) => {
      onSelect?.(event, client);
    },
    [onSelect],
  );

  return clients.length > 0 ? (
    <>
      <List className={clsx(s.root, className)} {...other}>
        {clients.map((client, index) => {
          const selected = singleSelect
            ? selectedClient?.id === client.id
            : false;

          return (
            <ClientListItem
              key={client.id}
              client={client}
              divider={index < clients.length - 1}
              onClick={(e) => handleClick(e, client)}
              selected={selected}
              singleSelect={singleSelect}
            />
          );
        })}
      </List>

      {hasNext && (
        <Button onClick={handleMoreClick} fullWidth disabled={loading}>
          Load more
        </Button>
      )}
    </>
  ) : (
    <EnrollDialogEmpty
      header={debounceQuery ? "No clients match your search" : "No clients"}
    />
  );
}
